import { Component, OnInit } from '@angular/core';
import { LoadingPage } from '../../../compartido/cargando/loading';
import { AsociacionJefeDependenciaService, PlanificacionCateringService, DisponibilidadService, ConfiguracionGeneralService } from 'npm-servicios-catering';
import { DatosSesionService } from '../../servicios/datos-sesion.service';
import { PlanificacionCatering, AsociacionPersona, DisponibilidadPlanificacion, DisponibilidadDTO } from 'npm-modelado-catering';
import { Constantes } from '../../../compartido/constantes/constantes';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RequerimientoCateringService } from 'npm-servicios-catering';
import { RequerimientoCateringDTO } from 'npm-modelado-catering';
import { MenuService } from '../../servicios/menu.service';
import { AppComponent } from '../../app.component';



@Component({
  selector: 'app-planificacion-listar',
  templateUrl: './planificacion-listar.component.html',
  styleUrls: ['./planificacion-listar.component.css']
})
export class PlanificacionListarComponent extends LoadingPage implements OnInit {

  busy: Subscription;
  
  existePlanificacion: boolean = true;
  existeAsociacionPersona: boolean = false;
  existeRequerimientos: boolean=false;
  
  idUnidadLogueada: number;
  idAsociacionPersona: number;

  disableMesActual: boolean;
  disableMesSiguiente: boolean;
  disponibilidad : DisponibilidadDTO;

  lstPlanificacionCatering: PlanificacionCatering[];
  lstRequerimientoCateringDTO: RequerimientoCateringDTO[];
  _lstPlanificacionesAnteriorActual: PlanificacionCatering[];
  lstAuxRequerimientos: RequerimientoCateringDTO[];
  lstIdsRequerimientos: Number [] =[];

  mesActual: string;
  mesSiguiente: string;
  mesSeleccionado: string;

  planificacion: PlanificacionCatering;
  selectedPlanificacionCatering: PlanificacionCatering;
  valorTotalTemp: number =0;
  validarSeleccion: boolean= true;
  verificarEstadoPorAprobar: boolean= true;

  display: boolean;
  tamanio : number=0;

  lstDisponibilidades: DisponibilidadDTO [];

  mesPlanificacion: string;
  mapDisponibilidad = new Map();

  constructor(
    public app: AppComponent,
    private asociacionPersonaService: AsociacionJefeDependenciaService, private configuracionGeneralService: ConfiguracionGeneralService,
    private datosSessionService: DatosSesionService, private planificacionCateringService: PlanificacionCateringService,
    private confirmationService: ConfirmationService, private router: Router,
    private requerimientoCateringService: RequerimientoCateringService, private serviciosMenu: MenuService,
    private disponibilidadService: DisponibilidadService) {
    super(true);

  }

  ngOnInit() {

    this.idUnidadLogueada = this.datosSessionService.unidadSeleccionadaAplicativo.idUnidad;
   
    this.planificacion = new PlanificacionCatering();
    this.cargarMesPlanificacion();
    this.cargarEnviroments(); 
   
    this.datosSessionService.getAplicativo();
    this.datosSessionService.getCorreoUsuario();
    this.listar();
    //this.validarVisualizacionMeses();
    
  }

  obtenerRequerimientosCateringByIdPlanificacion() {
    this.busy = this.requerimientoCateringService.buscarByIdPlanificacionParaSumarTotal(this.datosSessionService.idPlanificacionActual).then(req => {
      if (req) {
        this.lstRequerimientoCateringDTO = req;
        for (var i = 0; i < this.lstRequerimientoCateringDTO.length; i++) {
          this.lstRequerimientoCateringDTO[i].valorTotalRequerimiento = this.lstRequerimientoCateringDTO[i].valorUnitarioSubCategoria * this.lstRequerimientoCateringDTO[i].cantidad;
        } 
      }
    }).catch(error => {
      this.mostrarMensajeError("No se encuentra disponible el servicio de listar servicios, intente más adelante refrescando la pestaña o comuníquese con el administrador");
    });
  }

  agregarClick() {
      this.display=true;     
  }

  cancelarClick(){
    this.display=false;
    this.mesSeleccionado="";
    this.validarSeleccion=true;
    
  }
  cargarMesPlanificacion(){
    let fechaActual = new Date();

    if (fechaActual.getMonth() != 11) {
      this.mesActual = Constantes.MESES[fechaActual.getMonth()].label.toUpperCase();
      this.mesSiguiente=Constantes.MESES[fechaActual.getMonth()+1].label.toUpperCase();

    } else {
      this.mesActual="DICIEMBRE";
      this.mesSiguiente= "ENERO"
    }
    
  }

  actualizarEstadoRequerimientos(){ 
    return new Promise(resolve =>{
        this.requerimientoCateringService.listarRequerimientoCateringByIdPlanificacion(this.selectedPlanificacionCatering.idPlanificacionCatering).then( responselstRequerimiento =>{
          if(responselstRequerimiento){
              this.lstAuxRequerimientos = responselstRequerimiento;
              resolve();                
          }
        });
    });
  }

  async enviarTodoClick(){
    if(this.selectedPlanificacionCatering){
      await this.actualizarEstadoRequerimientos();
      await this.validarDisponibilidad();   
      if(this.lstAuxRequerimientos.length>0){
        this.validar();
      }else{
        this.mostrarMensajeInfo("No existen servicios registrados");
      }
    }
  }

  actualizarRequerimiento(){
    if(this.lstAuxRequerimientos.length>0){
        for(let i=0 ; i< this.lstAuxRequerimientos.length ; i++){
          this.lstIdsRequerimientos.push(this.lstAuxRequerimientos[i].idRequerimientoCatering)
        }
      
        this.requerimientoCateringService.actualizarRequerimientoCatering(this.lstIdsRequerimientos, Constantes.ESTADO_PORAPROVAR).then((responseActualizar:boolean)=>{
          if(responseActualizar){                  
            this.lstIdsRequerimientos=[]
            this.lstAuxRequerimientos=null;
            this.mostrarMensajeInfo("Registros actualizado con exito");
            this.listar();
            this.tamanio=0;
          }
        });          
    }
  }

  verificarEstadoRegistros(){
    return new Promise(resolve =>{
      this.tamanio=0;
      this.lstAuxRequerimientos.forEach( element=>{
        if(element.nombreEstadoRequerimiento!=Constantes.ESTADO_ELABORADA){
           this.verificarEstadoPorAprobar= false;   
        } 

        if(element.nombreEstadoRequerimiento==Constantes.ESTADO_PORAPROVAR ){
           this.tamanio= this.tamanio +1;
        }
        resolve();
     });
    });
  }

  validarDisponibilidad(){
    return new Promise(resolve =>{
      this.lstAuxRequerimientos.forEach(value => {    
          this.disponibilidadService.buscarDisponibilidad(value.idDisponibilidadPlanificacion).then(resp=>{
            if(resp){
              let disponibilidad : DisponibilidadPlanificacion;
              disponibilidad= resp;
              this.mapDisponibilidad.set(value.idRequerimientoCatering,disponibilidad.fechaFin)
              resolve();
            }
          });
      })
    });
   }

  verificarServiciosIsNormalIsExcepcional(tipoMensaje):boolean{
      let resultado = true;
      let fechaActual = new Date();
      fechaActual.setHours(0,0,0,0);
      let mensaje = this._tituloMensajeValidacionGrupal;
   
      this.lstAuxRequerimientos.forEach(req => {     
          if(req.tipoRequerimiento==Constantes.TIPO_DISPONIBILIDAD_NORMAL){
              if(req.nombreEstadoRequerimiento==Constantes.ESTADO_ELABORADA){         
                let fechaLimiteDisponibilidad = new Date(this.mapDisponibilidad.get(req.idRequerimientoCatering)+"T00:00:00");
                fechaLimiteDisponibilidad.setHours(0,0,0,0);
                if (fechaActual > fechaLimiteDisponibilidad) {
                  resultado= false;
                  mensaje += this._saltoLineaDetalle+" El servicio "+ req.idRequerimientoCatering +". No puede ser "+tipoMensaje+", No se encuentra dentro del tiempo permitido"
                }
              }
          }else{ //Validación de la fecha actual  cuando es excepcional         
              if(req.nombreEstadoRequerimiento==Constantes.ESTADO_ELABORADA){ 
                  let fechaEvento = new Date(req.fechaEvento+"T00:00:00")
                  fechaActual.setHours(0,0,0,0);
                  fechaEvento.setHours(0,0,0,0);
                  if(fechaActual > fechaEvento){
                      resultado= false;
                      mensaje += this._saltoLineaDetalle+" El servicio Excepcional"+ req.idRequerimientoCatering +". No puede ser "+tipoMensaje+", No se encuentra dentro del tiempo permitido"
                  }
              } 
            }
    });
    
    if(!resultado){
      this.mostrarMensajeError(mensaje);
    }
  
    return resultado;  
  }

  async validar(){     
      await this.verificarEstadoRegistros();
      if(this.tamanio==this.lstAuxRequerimientos.length){
            this.mostrarMensajeInfo("Los registros ya se encuentran enviados");
      }else{
          if(this.verificarEstadoPorAprobar){
            if(this.verificarServiciosIsNormalIsExcepcional("enviar para aprobación")){
                this.confirmarAprobarTodo();
            }
          }else{
            this.mostrarMensajeInfo("Los registros tienen estados diferentes, si desea enviar para aprobar ingrese a la planificación")
          }
      }
  }

  guardarClick(){
    this.confirmarCrearPlanificacion();
  }

  cargarEnviroments() {
    this.planificacionCateringService.set_constantes(Constantes);
    this.asociacionPersonaService.set_constantes(Constantes);
    this.requerimientoCateringService.set_constantes(Constantes);
    this.disponibilidadService.set_constantes(Constantes);
    this.configuracionGeneralService.set_constantes(Constantes);
  }

  confirmarAprobarTodo(){
    this.confirmationService.confirm({
      key: 'autorizacion',
      header: this._tituloAprobarRequerimiento,
      message: ' ¿Está seguro que desea enviar a revisión todos los servicios cátering de la planificación seleccionada?',
      accept: () => {
          this.actualizarRequerimiento();
      }
    });
  }

  confirmarCrearPlanificacion() {
    this.confirmationService.confirm({
      key: 'autorizacion',
      header: this._tituloCrearPlanificacion,
      message: '¿Está seguro que desea crear una planificación para ' + this.mesSeleccionado + '?',
      accept: () => {
        this.guardarPlanificacion();
      }
    })
  }

  continuarClick() {
    if (!this.selectedPlanificacionCatering) {
      this.mostrarMensajeInfo(this._noObjetoGrillaContinuar);
    } else {
      this.datosSessionService.nombrePlanificacionActual = this.selectedPlanificacionCatering.mes;
      this.datosSessionService.idPlanificacionActual = this.selectedPlanificacionCatering.idPlanificacionCatering;
      this.datosSessionService.fechaCreacionPlanificacion = new Date(this.selectedPlanificacionCatering.fechaCreacion);
      
      this.datosSessionService.guardarNombrePlanificacionActual(this.selectedPlanificacionCatering.mes);
      this.datosSessionService.guardarIdPlanificacionActual(this.selectedPlanificacionCatering.idPlanificacionCatering);
      this.datosSessionService.guardarFechaCreacionPlanificacion(new Date(this.selectedPlanificacionCatering.fechaCreacion));
      this.datosSessionService.tipoVistaActual="LISTADO";
      this.datosSessionService.guardarTipoVistaActual("LISTADO");
      this.router.navigate(['/planificacion/requerimiento-listar']); 
      

    }
  }
 

/*  buscarPlanificacionNormal() {
    this.planificacionCateringService.obtenerPlanificacionActivaPorFecha(this.idUnidadLogueada).then(responsePlanificacion => {
      if (responsePlanificacion) {
        this._lstPlanificacionesAnteriorActual= responsePlanificacion;
      }
    }).catch(error => this.mostrarMensajeError(error));
  }*/

  buscarSiExisteRequerimientosPorIdPlanificacion(idPlanificacion : number){
    return new Promise(resolve =>{
        this.requerimientoCateringService.listarRequerimientoCateringByIdPlanificacion(idPlanificacion).then(responselst =>{
            if(responselst){    
              if(responselst.length > 0){
                  this.existeRequerimientos=true;
              }else{
                  this.existeRequerimientos=false;
              }
              resolve();
            }
        });
    });
  }

  confirmarEliminarPlanificacion() {
    this.confirmationService.confirm({
      key: 'autorizacion',
      header: this._tituloCrearPlanificacion,
      message: '¿Está seguro que desea eliminar el registro?',
      accept: () => {
        this.eliminarPlanificacion();
      }
    })
  }

  eliminarPlanificacion(){
   
    this.planificacionCateringService.eliminarPlanificacion(this.selectedPlanificacionCatering.idPlanificacionCatering).then(responseEliminar=>{
      if(responseEliminar){ 
        this.disableMesActual= null;
        this.disableMesSiguiente=null;
         this.listar();
      }
    });
  }
 
  async listar() {
    try {
    
      this.busy = this.planificacionCateringService.listarPlanificacionPorDependencia(this.idUnidadLogueada).then((responseListarPlanificacion: PlanificacionCatering[]) => {
        if (responseListarPlanificacion) {
          this.lstPlanificacionCatering = responseListarPlanificacion;
                this.lstPlanificacionCatering.forEach(p=>{
                  this.busy = this.requerimientoCateringService.buscarByIdPlanificacionParaSumarTotal(p.idPlanificacionCatering).then(async req => {
                    if (req) {
                      
                      this.lstRequerimientoCateringDTO = req;
                      this.valorTotalTemp=0;
                      await this.sumaTotalRequerimientos();    
                      p.valorTotalPlanificacion = this.valorTotalTemp;//this.lstRequerimientoCateringDTO[i].valorTotalRequerimiento; 
                      p.valorTotalPlanificacion = Math.round(p.valorTotalPlanificacion * 10) / 10;
                                           
                      await this.validarVisualizacionMeses();

                      if(this.disableMesActual==true && this.disableMesSiguiente==true){
                        this.existePlanificacion=false;
                      }else{
                        this.existePlanificacion=true;
                      }
                    }
                  }).catch(error => {
                    this.mostrarMensajeError("No se encuentra disponible el servicio de listar servicios, intente más adelante refrescando la pestaña o comuníquese con el administrador");
                  });
                }); 
        }
      }).catch(error => this.mostrarMensajeError(error));
    } catch (error) {
      console.error("ERROR. listar", error);
      return false;
    }

  }

  guardarPlanificacion() {
    
    this.planificacion.estaActivo = Constantes.ESTA_ACTIVO_SI;
    this.planificacion.nombre = Constantes.PLANIFICACION;
    this.planificacion.mes = this.mesSeleccionado.toUpperCase();
    this.planificacion.idDependencia=this.idUnidadLogueada;
        
    this.planificacionCateringService.crear(this.planificacion).then(responseCrearPlanificacion => {
      if (responseCrearPlanificacion) {
        let planificacionCateringPrueba = new PlanificacionCatering();
        planificacionCateringPrueba = responseCrearPlanificacion;
   
        this.mesSeleccionado=null;
 
            this.listar();
            this.display=false;
            this.datosSessionService.fechaCreacionPlanificacion = this.planificacion.fechaCreacion;
            this.datosSessionService.guardarFechaCreacionPlanificacion(this.planificacion.fechaCreacion);
            this.existePlanificacion = true;
          /*}
        })*/
      }
    }).catch(error => this.mostrarMensajeError(error));
  }
 
  seleccion(){
    this.validarSeleccion=false;
  }

  sumaTotalRequerimientos(){
    this.lstRequerimientoCateringDTO.forEach(r=>{                        
      this.valorTotalTemp = this.valorTotalTemp+ r.valorUnitarioSubCategoria * r.cantidad;
    });       
  }

  async eliminarClick(){
      await this.buscarSiExisteRequerimientosPorIdPlanificacion(this.selectedPlanificacionCatering.idPlanificacionCatering);
      if(!this.existeRequerimientos){
          this.confirmarEliminarPlanificacion();
      }else{
          this.mostrarMensajeInfo(this._mensajeEliminarPlanificacion);
      }
      
  }

  async validarVisualizacionMeses(){
    console.log("Visualizacion de mes");
  
      if(this.mesActual!=null){
        console.log(this.mesActual)
          await this.buscarPlanificacionPorMes(this.mesActual);
      }

      if(this.mesSiguiente!=null){
        console.log( this.mesSiguiente)
          await this.buscarPlanificacionPorMes(this.mesSiguiente);
      }
  }

  buscarPlanificacionPorMes(mes){
    let fecha= new Date();
    let a_o= fecha.getFullYear();
      return new Promise(resolve =>{
        this.planificacionCateringService.buscarPlanificacionPorMesA_o(mes,a_o,this.idUnidadLogueada).then(responseBuscarMes=>{
            if(responseBuscarMes){
              console.log(responseBuscarMes)
                console.log("recupera")
                let planificacionC = new 
                PlanificacionCatering;
                planificacionC = responseBuscarMes;
                if(planificacionC != null){
                  if(planificacionC.mes==this.mesActual){
                    this.disableMesActual= true;
                 
                    resolve();
                  }

                  if(planificacionC.mes==this.mesSiguiente){
                  
                    this.disableMesSiguiente = true;
                    resolve();
                  }
                }
                resolve();
            }else{
              console.log()
              resolve();
            }
            
        });
      });
  }

 
}
